/** Client-side mirror of server emit matrix (keep in sync with server/config/demoTypes.ts). */

export type DemoChannel = 'slack' | 'teams' | 'gchat' | 'whatsapp' | 'email';
export type DemoMessageType =
  | 'insight'
  | 'pulse'
  | 'recognition-manager'
  | 'recognition-peer'
  | 'one-on-one-manager';
export type DemoLanguage = 'es' | 'en';

export const CHANNELS: { id: DemoChannel; label: string }[] = [
  { id: 'slack', label: 'Slack' },
  { id: 'teams', label: 'Teams' },
  { id: 'gchat', label: 'Google Chat' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'email', label: 'Email' },
];

/** Primary channel buttons shown in one row. */
export const PRIMARY_CHANNELS: { id: DemoChannel; label: string }[] = [
  { id: 'slack', label: 'Slack' },
  { id: 'teams', label: 'Teams' },
  { id: 'gchat', label: 'Google Chat' },
];

/** Channels tucked behind the kebab “more” menu. */
export const MORE_CHANNELS: { id: DemoChannel; label: string }[] = [
  { id: 'email', label: 'Email' },
  { id: 'whatsapp', label: 'WhatsApp' },
];

/** Primary message buttons shown in one row. */
export const PRIMARY_MESSAGE_TYPES: { id: DemoMessageType; label: string }[] = [
  { id: 'insight', label: 'Insight' },
  { id: 'pulse', label: 'Pulso' },
];

/** Message types tucked behind the kebab “more” menu. */
export const MORE_MESSAGE_TYPES: { id: DemoMessageType; label: string }[] = [
  { id: 'recognition-manager', label: 'Kudo (manager)' },
  { id: 'recognition-peer', label: 'Kudo (empleado)' },
  { id: 'one-on-one-manager', label: '1:1 pendiente' },
];

export const MESSAGE_TYPES: { id: DemoMessageType; label: string }[] = [
  ...PRIMARY_MESSAGE_TYPES,
  ...MORE_MESSAGE_TYPES,
];

const KAI_REMINDER_TYPES = [
  'recognition-manager',
  'recognition-peer',
  'one-on-one-manager',
] as const;

const SUPPORTED: Record<DemoChannel, readonly DemoMessageType[]> = {
  slack: ['insight', 'pulse', ...KAI_REMINDER_TYPES],
  teams: ['insight', 'pulse', ...KAI_REMINDER_TYPES],
  gchat: ['insight', 'pulse', ...KAI_REMINDER_TYPES],
  whatsapp: ['pulse'],
  email: ['pulse', ...KAI_REMINDER_TYPES],
};

export function isEmitSupported(channel: DemoChannel, messageType: DemoMessageType): boolean {
  return SUPPORTED[channel].includes(messageType);
}

export type ChannelDestinationSummary = {
  kindLabel: string;
  value: string;
};

export type SalespersonOption = {
  id: string;
  name: string;
  /** Only channels with a configured destination. */
  channels: Partial<Record<DemoChannel, ChannelDestinationSummary>>;
};
